import React, { useState } from 'react';
import { adminLogin } from '../services/api';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f7fafc',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    padding: '48px',
    width: '400px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
  },
  heading: { fontSize: '24px', fontWeight: '700', marginBottom: '8px', color: '#1a202c' },
  subheading: { fontSize: '14px', color: '#718096', marginBottom: '32px' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#4a5568', marginBottom: '6px' },
  input: {
    width: '100%', padding: '12px 16px', border: '2px solid #e2e8f0', borderRadius: '8px',
    fontSize: '16px', outline: 'none', marginBottom: '20px',
  },
  button: {
    width: '100%', padding: '14px', background: '#9C3D97', color: '#fff', border: 'none',
    borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
  },
  error: {
    background: '#fed7d7', color: '#c53030', padding: '12px', borderRadius: '8px',
    marginBottom: '20px', fontSize: '14px',
  },
};

export default function LoginPage({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await adminLogin(email, password);
      if (result.error) {
        setError(result.error);
      } else {
        onSuccess();
      }
    } catch {
      setError('Unable to connect.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src="/hellorache-logo.jpg" alt="HelloRache" style={{ height: '48px', marginBottom: '16px' }} />
        </div>
        <h1 style={styles.heading}>AI Chart Checking Tool</h1>
        <p style={styles.subheading}>HelloRache HVA Training</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} required autoFocus />
          <label style={styles.label}>Password</label>
          <input style={styles.input} type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
          <button style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
            type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
